import { Store } from "app-core";
import _sfc_main$3 from "./index20.js";
/* empty css        */
import _sfc_main$2 from "./index18.js";
/* empty css        */
import _sfc_main$1 from "./index22.js";
/* empty css        */
import _sfc_main from "./index24.js";
/* empty css        */
import ReceiptCreditNoteLocalizationMe from "./index27.js";
import ReceiptCreditNoteLocalizationEn from "./index26.js";
function loadLocalizedComponent(componentName) {
  const locale = Store.get("locale");
  if (componentName === "ReceiptInvoice") return getReceiptInvoiceLocalization(locale);
  else if (componentName === "ReceiptCreditNote") return getReceiptCreditNoteLocalization(locale);
  return void 0;
}
function getReceiptInvoiceLocalization(locale) {
  switch (locale) {
    case "me":
      return _sfc_main$3;
    case "sr":
      return _sfc_main$2;
    case "ba":
      return _sfc_main$1;
    default:
      return _sfc_main;
  }
}
function getReceiptCreditNoteLocalization(locale) {
  switch (locale) {
    case "me":
      return ReceiptCreditNoteLocalizationMe;
    default:
      return ReceiptCreditNoteLocalizationEn;
  }
}
function useLocalization() {
  return {
    loadLocalizedComponent
  };
}
export {
  useLocalization
};
//# sourceMappingURL=index105.js.map
